import { createActions, createReducer } from 'reduxsauce'

import OrgaosService from '../servicos/OrgaosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaOrgaoInicio: [],
    buscaOrgaoSucesso: ['orgao'],
    buscaOrgaoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaOrgaos = exercicio => {
    return dispatch => {
        dispatch(Creators.buscaOrgaoInicio())
        let serv = new OrgaosService()
        return serv
            .getOrgaos(exercicio)
            .then(response => dispatch(Creators.buscaOrgaoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaOrgaoErro(error)))
    }
}

const buscaOrgaoInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaOrgaoErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaOrgaoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.orgao, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ORGAO_INICIO]: buscaOrgaoInicio,
    [Types.BUSCA_ORGAO_ERRO]: buscaOrgaoErro,
    [Types.BUSCA_ORGAO_SUCESSO]: buscaOrgaoSucesso,
})
